import React, { useState, useEffect } from 'react';
import locationCache from '../../utils/locationCache';

const GeoapifyComponent = ({ latitude, longitude, onAddressFetched }) => {
    const [address, setAddress] = useState('Fetching address...');
    const API_KEY = "b20adba3a72241948593ece1f0e8f68e";

    useEffect(() => {
        const getAddressFromCoordinates = async () => {
            // Round latitude and longitude to 3 decimal places
            // const roundedLatitude = parseFloat(latitude.toFixed(3));
            // const roundedLongitude = parseFloat(longitude.toFixed(3));

            // Check cache first
            const cached = locationCache.get(latitude, longitude);
            if (cached) {
                setAddress(cached.address);
                onAddressFetched && onAddressFetched(cached);
                return;
            }

            try {
                const response = await fetch(`https://api.geoapify.com/v1/geocode/reverse?lat=${latitude}&lon=${longitude}&apiKey=${API_KEY}`);
                const json = await response.json();

                if (json.features && json.features.length > 0) {
                    const formattedAddress = json.features[0].properties.formatted;
                    setAddress(formattedAddress);

                    // Cache the result
                    const locationData = {
                        address: formattedAddress,
                        latitude: latitude,
                        longitude: longitude,
                        accuracy: null,
                        placeType: json.features[0].properties.category || [],
                        confidence: 100,
                        context: json.features[0].properties || [],
                        source: 'geoapify'
                    };
                    locationCache.set(latitude, longitude, locationData);
                    onAddressFetched && onAddressFetched(locationData);
                } else {
                    setAddress('No address found for these coordinates.');
                    onAddressFetched && onAddressFetched(null);
                }
            } catch (error) {
                console.error('Error fetching address:', error);
                setAddress('Error fetching address.');
                onAddressFetched && onAddressFetched(null);
            }
        };

        if (latitude && longitude && latitude !== "00" && longitude !== "000") {
            getAddressFromCoordinates();
        }
    }, [latitude, longitude, onAddressFetched]);

    return null; // No UI, just fetches and calls back
};

export default GeoapifyComponent;
